import { createContext } from 'react';
export const defaultGridConfig = { gutter: ['sm', 'xl'] };
const GridContext = createContext(defaultGridConfig);
export default GridContext;
